import classNames from "classnames";
import { PropsWithChildren } from "react";
import styles from "./blured.module.scss";

type Props = PropsWithChildren<{ className?: string; text?: string }>;

export const Blured = ({ children, className, text }: Props) => {
  return (
    <div className={classNames(styles.bluredWrapper, className)}>
      <div className={styles.blured}>{children}</div>
      {text && <div className={styles.text}>{text}</div>}
    </div>
  );
};
